import { component } from 'picoapp'
import '@/lib/jquery-global.js';

export default component((node, ctx) => {

    const slider = jQuery(node.querySelector('.js-events'))

    slider.slick({
        dots: false,
        arrows: true,
        draggable: true,
        swipe: true,
        nextArrow: jQuery('.js-next'),
        prevArrow: jQuery('.js-prev'),
        slidesToShow: 7,
        slidesToScroll: 7,
        initialSlide: 100,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 3
                }
            }
        ]
    });

    // jQuery('.js-date').click(function() {

    //     jQuery('.js-date').removeClass('current');

    //     let date = jQuery(this).data('date');
    //     jQuery(this).addClass('current')

    //     jQuery('.js-block').hide();
    //     jQuery('.js-empty').hide();

    //     console.log(node.querySelector('.js-block[data-date="' + date + '"'))

    //     if (node.querySelector('.js-block[data-date="' + date + '"')) {
    //         jQuery('.js-block[data-date="' + date + '"').show();
    //     } else {
    //         console.log('no date')
    //         jQuery('.js-empty').show();
    //     }

    // });

})

